import {
  Injectable
} from '@angular/core';
import {
  UserInfo
} from '../../models';

import {
  UserToken
} from '../../models';
import {BehaviorSubject} from 'rxjs';
import {ApiService} from '../api';
import {JwtHelperService} from '@auth0/angular-jwt';

@Injectable()
export class SearchContext {

  searchObserver: BehaviorSubject<string> = new BehaviorSubject<string>("");

  constructor() {

  }

}
